/* eslint-disable */
import createIcon from '../createIcon';

const IconArrowDownOutlined = createIcon({
  name: 'icon-arrow-down-outlined',
  content: '<path d="M828.248413 516.524207l-315.420037 315.420037-45.050902-45.050902 315.420037-315.420038z"/><path d="M242.013192 471.154698l315.420038 315.420038-45.050903 45.050902-315.420037-315.420038z"/><path d="M481.732421 767.840697v-637.212197h63.721219v637.212197z"/>',
  width: 1024,
  height: 1024
}, 'Icon');
export default IconArrowDownOutlined;
